export enum FilterTypesEnum {
  input = 'input',
  dateRange = 'dateRange',
  select = 'select',
  date = 'date',
  number = 'number',
}
